export default {
  en: {
    fallbackTitle: 'Dictionary',
    renameDictionary: 'Rename dictionary {{name}}',
    addWord: 'Add word',
    deleteDictionary: 'Delete dictionary',
    emptyTitle: "It's empty here",
    emptyBody: 'Tap unfamiliar words in the AI tutor chat — they will show up here',
    wordColumn: 'Word',
    translationColumn: 'Translation',
    statusColumn: 'Status',
    actionsColumn: 'Actions',
    dictionaryWordsAriaLabel: 'Words of dictionary {{name}}',
    deleteWord: 'Delete word {{word}}',
    addWordTitle: 'Add word',
    addSubmit: 'Add',
    editWordTitle: 'Edit word',
    saveSubmit: 'Save',
    renameDictionaryTitle: 'Rename dictionary',
    confirmDeleteTitle: 'Delete dictionary?',
    confirmDeleteMessage: '"{{name}}" and all its words will disappear along with all their learning progress. This cannot be undone.',
    confirmDeleteFallback: 'Delete dictionary "{{name}}"? All its words and all their learning progress will disappear with no way to undo it.',
    deleteConfirm: 'Delete',
    loadingDictionary: 'Loading dictionary',
  },
  ru: {
    fallbackTitle: 'Словарь',
    renameDictionary: 'Переименовать словарь {{name}}',
    addWord: 'Добавить слово',
    deleteDictionary: 'Удалить словарь',
    emptyTitle: 'Пока тут пусто',
    emptyBody: 'Нажимай на незнакомые слова в чате с AI репетитором — они появятся здесь',
    wordColumn: 'Слово',
    translationColumn: 'Перевод',
    statusColumn: 'Статус',
    actionsColumn: 'Действия',
    dictionaryWordsAriaLabel: 'Слова словаря {{name}}',
    deleteWord: 'Удалить слово {{word}}',
    addWordTitle: 'Добавить слово',
    addSubmit: 'Добавить',
    editWordTitle: 'Редактировать слово',
    saveSubmit: 'Сохранить',
    renameDictionaryTitle: 'Переименовать словарь',
    confirmDeleteTitle: 'Удалить словарь?',
    confirmDeleteMessage: '«{{name}}» и все слова в нём исчезнут вместе со всем прогрессом их изучения. Отменить это будет нельзя.',
    confirmDeleteFallback: 'Удалить словарь «{{name}}»? Все слова в нём и весь прогресс их изучения исчезнут без возможности отмены.',
    deleteConfirm: 'Удалить',
    loadingDictionary: 'Загружаю словарь',
  },
};
